export default __webpack_public_path__ + "dbbbaabcd6e76db5106473683daf0542.svg";